import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { Loader } from "rizzui/loader";

export default function Signout() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("isLogin");
    navigate("/account/login");
  }, []);
  return (
    <div className="w-full h-full flex items-center justify-center">
      <Loader />
    </div>
  );
}
